import React, { useState, useEffect } from 'react';
import './App.css';
import AuthModal from './components/shared/AuthModal';
import Header from './components/landing/Header';
import HeroBanner from './components/landing/HeroBanner';
import GirlsGrid from './components/landing/GirlsGrid';
import useGTM from './hooks/useGtm';
import { initTracking } from './utils/tracking';
import BottomBanner from './components/landing/BottomBanner';
import { useGirlsData } from './hooks/useGirlsData';
import { useGrowthbook } from './hooks/useGrowthbook';
import { CDN_BASE_URL } from './config/constants';
import { AuthRedirectIntent, Girl } from './types';
import { buildCreateAiRedirectUrl } from './utils/api';

function App() {
  useGTM();
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const [redirectIntent, setRedirectIntent] = useState<AuthRedirectIntent>({
    kind: 'create-ai',
  });
  const { girls: aiGirls, loading: isLoading } = useGirlsData();
  const { features } = useGrowthbook();
  console.log('features.authVideo', features.authVideo);

  const authVideoUrl = features.authVideo
    ? features.authVideo.startsWith('https://')
      ? features.authVideo
      : `${CDN_BASE_URL}/${features.authVideo}`
    : undefined;

  useEffect(() => {
    initTracking();
  }, []);

  // "Create My Slut" CTA — redirect straight to the Swipey /create-ai funnel
  // anonymously (no auth_token), the same way the other /create-ai landers
  // (kawaii-slut, ai-pornub, swipeymatch) do. Registration happens on Swipey,
  // so we no longer open the on-lander auth form for this CTA.
  const openCreateAiModal = () => {
    window.location.href = buildCreateAiRedirectUrl();
  };

  const openChatModal = (girl: Girl) => {
    setRedirectIntent({ kind: 'chat', characterSlug: girl.slug });
    setIsAuthModalOpen(true);
  };

  return (
    <div className="min-h-screen bg-[#1F1B29] lg:bg-[#14002F] font-poppins">
      {/* Mobile container - full width on desktop */}
      <div className="max-w-[390px] lg:max-w-none mx-auto bg-[#1F1B29] lg:bg-[#14002F] min-h-screen relative">
        <Header />
        <HeroBanner onCreateClick={openCreateAiModal} />

        {isLoading ? (
          <div className="px-4 text-center text-white">Loading...</div>
        ) : (
          <GirlsGrid girls={aiGirls} onCardClick={openChatModal} />
        )}
      </div>
      <div className="max-w-[390px] lg:max-w-none mx-auto bg-[#1F1B29] lg:bg-[#14002F] relative">
        <BottomBanner onCreateClick={openCreateAiModal} />
      </div>

      {/* Auth Modal */}
      <AuthModal
        isOpen={isAuthModalOpen}
        onClose={() => setIsAuthModalOpen(false)}
        initialView="signup"
        videoUrl={authVideoUrl}
        redirectIntent={redirectIntent}
      />
    </div>
  );
}

export default App;
